export const createFileList = (files: File[]) => {
  const dataTransfer = new DataTransfer();

  files.forEach((file) => {
    dataTransfer.items.add(file);
  });

  return dataTransfer.files;
};

export const getLimitedFiles = (
  files: File[],
  multiple: boolean,
  limit?: number,
) => {
  const maxFiles = multiple ? limit : 1;

  if (maxFiles === undefined) {
    return files;
  }

  if (maxFiles < 1) {
    return [];
  }

  return files.slice(0, maxFiles);
};
